// AIMS PWA - local QR scan history (Dexie).
//
// Records every scan performed in the in-app scanner, whether or not it resolved
// to a real asset. We always know two things from deconstructing the tag: the
// identifier type ('a' = assetId, 'c' = catNo, '?' = unknown) and the scanned
// value - so the log is meaningful even for a miss.
//
// Stored in the AIMSOffline Dexie DB (scanHistory store). The scanner AWAITS
// recordScan() before navigating on an online scan, so the write is durably
// committed before any page redirect (no lost entries).

import db from './db';

const MAX = 300; // keep the most recent N; trim older beyond that

// entry: { id (auto), idType: 'a'|'c'|'?', value, raw, ts (ms epoch) }
export async function recordScan({ idType, value, raw } = {}) {
  const val = value || raw || '';
  if (!val) return;
  try {
    await db.scanHistory.add({
      idType: idType === 'a' || idType === 'c' ? idType : '?',
      value: val,
      raw: raw || val,
      ts: Date.now(),
    });
    // Trim oldest beyond MAX (cheap: only when we exceed it).
    const count = await db.scanHistory.count();
    if (count > MAX) {
      const overflow = count - MAX;
      const oldest = await db.scanHistory.orderBy('ts').limit(overflow).primaryKeys();
      if (oldest.length) await db.scanHistory.bulkDelete(oldest);
    }
  } catch (_) { /* IndexedDB unavailable (private mode etc.) - non-critical */ }
}

// Most recent first.
export async function getScanHistory(limit = MAX) {
  try {
    return await db.scanHistory.orderBy('ts').reverse().limit(limit).toArray();
  } catch (_) {
    return [];
  }
}

export async function clearScanHistory() {
  try { await db.scanHistory.clear(); } catch (_) { /* ignore */ }
}
